import { debugLog } from '@schibsted-nmp/advertising-shared';

import { Api } from './Api/index.js';

export namespace LazyLoad {
  const DEFAULT_RENDER_MARGIN_PERCENT = 10;
  const DEFAULT_FETCH_MARGIN_PERCENT = 30;
  const DEFAULT_MOBILE_SCALING = 1.0;

  export async function enable(...abortSignals: ReadonlyArray<AbortSignal>) {
    const lazyLoadConfig = getConfig();

    debugLog('Enabling google tag lazy load with config: ', lazyLoadConfig);

    await Api(...abortSignals).setConfig({ lazyLoad: lazyLoadConfig });
  }

  export function getConfig() {
    const config = {
      renderMarginPercent: DEFAULT_RENDER_MARGIN_PERCENT,
      fetchMarginPercent: DEFAULT_FETCH_MARGIN_PERCENT,
      mobileScaling: DEFAULT_MOBILE_SCALING
    } satisfies googletag.LazyLoadOptionsConfig;

    return config;
  }

  let restorePending = false;

  export function disableUntilWallpaperRenders(googletag: Api.Loaded) {
    restorePending = true;
    debugLog('Disabling lazy load for wallpaper refresh');
    googletag.setConfig({ lazyLoad: null });
  }

  export async function restoreAfterWallpaperRender(
    ...abortSignals: ReadonlyArray<AbortSignal>
  ) {
    if (!restorePending) return;
    restorePending = false;

    debugLog('Restoring lazy load after wallpaper render');
    await Api(...abortSignals).setConfig({ lazyLoad: getConfig() });
  }
}
